export default [
    {
        field: 'max_apv_monthly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Mensual',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'max_apv_yearly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Anual',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
]
